<template>
    <div id="app">
        <p-header></p-header>
        <transition name="fade" mode="out-in">
            <router-view></router-view>
        </transition>
        <p-footer></p-footer>
        <p-service></p-service>
    </div>
</template>

<script>
    import PHeader from "src/components/header"
    import PFooter from "src/components/footer"
    import PService from "src/components/service"
    export default {
        components: {
            PHeader,
            PFooter,
            PService
        }
    }
</script>

<style lang="scss">
    @import 'src/assets/style/index.scss';
    @import 'src/assets/style/variable.scss';
    #app {
        min-height: 600px;
    }

    .tk-container {
        width: 1190px;
        margin: $px10*3 auto; // position: relative;
        min-height: $px10*60;
    }

    .tk-navbar {
        @include border;
        margin-bottom: $px10*2;
        background-color: $cl-white;
        .mod-search {
            width: 200px;
            height: 30px;
            position: absolute;
            right: 14px;
            top: 14px;
            input {
                height: 30px;
                border: 2px solid $cl-gray-bd;
                border-radius: 4px;
                box-sizing: border-box;
                font-size: 14px;
                padding: 0 20px 0 10px;
            }
            .iconfont {
                font-size: 18px;
                position: absolute;
                right: 0;
                top: 5px;
                color: $cl-gray-l;
                cursor: pointer;
            }
        }
        .navbar-child {
            padding: 20px 0 10px 30px;
            font-size: $px14;
            border-top: 1px solid $cl-gray-bd;
            position: relative;
            .title {
                position: absolute;
                top: 0;
                left: 0;
                color: darken($cl-gray-bd, 30%);
            }
            .child-item {
                float: left;
                width: 815px;
                height: $px10*2;
                overflow: hidden;
                position: relative;
                padding-left: 40px;
                &.active {
                    height: auto;
                }
                dd {
                    float: left;
                    margin: 0 $px12 $px12 $px12;
                    cursor: pointer;
                    &:hover {
                        color: $cl-current-l;
                    }
                    &.hidden {
                        display: none;
                    }
                    &.current {
                        color: $cl-current-l;
                        font-weight: bold;
                        cursor: default;
                    }
                }
            }
            .more {
                color: darken($cl-gray-bd, 20%);
                font-size: $px12;
                cursor: pointer;
                &:hover {
                    color: $cl-current-l;
                }
                .iconfont {
                    font-size: $px12;
                    margin-right: $px10/2;
                }
            }
        }
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: all 0.1s;
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }
</style>


// WEBPACK FOOTER //
// src/App.vue